import React from "react"

import { Form, Formik, FormikHelpers } from "formik"
import { NotificationManager } from "react-notifications"
import * as Yup from "yup"

import { adminClient as client } from "src/urql-client"

import { gql, useMutation } from "hooks/urql"

import {
  SelectField,
  handleFailure,
} from "components/Forms/Formik/hookComponents"

import ModalWithProvidedBody, { Footer } from "../ModalWithProvidedBody"

type ResetTailoredAssignmentUserProps = {
  userId: string
  tailoredAssignmentId: string
  tailoredAssignmentUserState: "completed" | "in_progress"
}

type AasmStateFormValues = "inProgress" | "initial" | ""

interface FormValues {
  userId: string
  tailoredAssignmentId: string
  aasmState: AasmStateFormValues
}

const ValidationSchema = Yup.object().shape({
  aasmState: Yup.string().required("Selection is required"),
})

const ResetTailoredAssignmentUserModal: React.FC<
  ResetTailoredAssignmentUserProps
> = ({ userId, tailoredAssignmentId, tailoredAssignmentUserState }) => {
  const [, runMutation]: any[] = useMutation(
    updateTailoredAssignmentUserMutation,
    client
  )

  const editOptions = [
    { label: "Unstarted", value: "initial" },
    {
      label: "In Progress",
      value: "inProgress",
      isDisabled: tailoredAssignmentUserState === "in_progress",
    },
  ]

  const initialValues: FormValues = {
    userId,
    tailoredAssignmentId,
    aasmState: "",
  }

  const handleSubmit = async (
    values: FormValues,
    actions: FormikHelpers<FormValues>,
    closeModal: () => void
  ) => {
    runMutation(values)
      .then(
        result => {
          const { failures } = result.data.updateTailoredAssignmentUser
          if (failures.length > 0) {
            handleFailure(actions, failures)
          } else {
            closeModal()
            NotificationManager.success("Updated Successfully")
          }
        },
        () => handleFailure(actions)
      )
      .catch(() => handleFailure(actions))
  }

  return (
    <ModalWithProvidedBody
      buttonText="Reset"
      buttonClassName="p-0 max-w-max border-0 bg-transparent text-red-500 hover:underline font-normal cursor-pointer focus:outline-none"
      modalClassName="bootstrap-modal"
      modalTitle="Update Tailored Assignment"
    >
      {({ closeModal }) => (
        <Formik
          initialValues={initialValues}
          validationSchema={ValidationSchema}
          onSubmit={(values, actions) =>
            handleSubmit(values, actions, closeModal)
          }
        >
          <Form>
            <div className="modal-body">
              <SelectField
                name="aasmState"
                label="What state would you like to reset to?"
                options={editOptions}
                menuPortalTarget={document.body}
              />
            </div>
            <Footer cancelAction={closeModal} />
          </Form>
        </Formik>
      )}
    </ModalWithProvidedBody>
  )
}

const updateTailoredAssignmentUserMutation = gql`
  mutation UpdateTailoredAssignmentUser(
    $userId: ID!
    $tailoredAssignmentId: ID!
    $aasmState: TailoredAssignmentUserStateEnum!
  ) {
    updateTailoredAssignmentUser(
      userId: $userId
      tailoredAssignmentId: $tailoredAssignmentId
      aasmState: $aasmState
    ) {
      failures {
        message
      }
    }
  }
`

export default ResetTailoredAssignmentUserModal
